"use client";
import { useNavigate } from "react-router-dom";
import { ListChecks, Plus } from "lucide-react";

import PageContainer from "@/app/admin/_common/PageContainer";
import PageHeader from "@/app/admin/_common/PageHeader";
import CuoButton from "@/app/admin/_common/CuoButton";

import { useChecklistsModel } from "./checklistsPageModel";
import ChecklistTemplateList from "./_cmp/ChecklistTemplateList";
import ChecklistsToolbar from "./_cmp/ChecklistsToolbar";

export default function ChecklistsPage() {
  const navigate = useNavigate();
  const { templates, totalCount, isLoading, search, setSearch, handleDelete } =
    useChecklistsModel();

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PageHeader
          title="Show Checklists"
          icon={ListChecks}
          subtitle={`${totalCount} ${totalCount === 1 ? "template" : "templates"}`}
          actions={
            <CuoButton
              icon={<Plus className="size-4" />}
              label="New template"
              onClick={() => navigate("/admin/tools/checklists/new")}
            />
          }
        />

        <div className="flex min-h-0 flex-1 flex-col gap-3 py-3 md:px-5 md:py-5">
          <ChecklistsToolbar search={search} onSearchChange={setSearch} />
          <ChecklistTemplateList
            templates={templates}
            isLoading={isLoading}
            onDelete={handleDelete}
          />
        </div>
      </div>
    </PageContainer>
  );
}
